import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import React from 'react'
import useStyles from './styles'
import { Note } from './Note';

const NotesDialog = ({ notes, open, onClose }) => {
    const classes = useStyles()
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle className={classes.dialogTitle}>Notas</DialogTitle>
            <IconButton className={classes.closeBtn} onClick={onClose}>
                <CloseIcon />
            </IconButton>
            <DialogContent className={classes.dialogContent}>
                {notes.length > 0 ? notes.map(note => (
                    <Note note={note} />
                )) :
                    <Typography>No hay notas</Typography>
                }
            </DialogContent>
        </Dialog>
    )
}

export { NotesDialog }